import { render } from "./LoginBranding.vue?vue&type=template&id=3dda64e6&scoped=true"
import script from "./LoginBranding.vue?vue&type=script&lang=js"
export * from "./LoginBranding.vue?vue&type=script&lang=js"

import "./login-layout.scss?vue&type=style&index=0&id=3dda64e6&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dda64e6"]])

export default __exports__